import { Outlet } from 'react-router-dom';
import { usePlatformTheme } from '@/hooks/usePlatformTheme';
import '@/styles/student-experience.css';

export function LessonLayout() {
  const { theme } = usePlatformTheme();

  return (
    <main id="member-main" tabIndex={-1} className="lesson-shell bg-background min-h-screen" data-theme={theme}>
      <Outlet />
    </main>
  );
}
